import { useEffect } from 'react';
import { APP_NAME } from '../Utils/Strings';

const usePageTitle = (title) => {
  useEffect(() => {
    document.title = `${APP_NAME} - ${title}`;
  }, [title]);
};

export default usePageTitle;
